import { makeStyles } from '@material-ui/core/styles'

import colors from '@galo-monitor/styles/colors'

const useStyles = makeStyles({
  root: {
    width: '100%',
    backgroundColor: 'transparent'
  },
  appBar: {
    position: 'relative',
    zIndex: 1099,
    width: '100%',
    boxShadow: 'none',
    background: 'transparent',
    borderBottom: `1px solid ${  colors.grey }`
  },
  mobileAppBar: {
    // position: 'fixed',
    // bottom: 0,
    // left: 0
  }
})

export default useStyles
